import type { SVGProps } from 'react';
import { ShuffleIcon } from './AcademicIcons';
import {
  AcademicCapIcon, BookmarkSquareIcon, BeakerIcon,
  BookOpenIcon, BuildingLibraryIcon, CalendarDaysIcon, CheckCircleIcon,
  ClockIcon, ComputerDesktopIcon, ExclamationTriangleIcon, LightBulbIcon,
  MagnifyingGlassIcon, MapPinIcon, StarIcon, SwatchIcon, UserGroupIcon,
  UserIcon, XCircleIcon,
} from '@heroicons/react/24/outline';

/** Functional symbols share one family, currentColor, and optical sizing. */
const icons = {
  save: BookmarkSquareIcon, shuffle: ShuffleIcon, calendar: CalendarDaysIcon,
  location: MapPinIcon, instructor: UserIcon, campus: BuildingLibraryIcon,
  time: ClockIcon, credits: BookOpenIcon, display: ComputerDesktopIcon,
  colors: SwatchIcon, warning: ExclamationTriangleIcon, suggestion: LightBulbIcon,
  complete: CheckCircleIcon, missing: XCircleIcon, rating: StarIcon,
  research: BeakerIcon, degree: AcademicCapIcon, search: MagnifyingGlassIcon,
  social: UserGroupIcon, academic: BookOpenIcon,
};
export type FunctionalIconName = keyof typeof icons;

export function FunctionalIcon({ name, className = '', ...props }: SVGProps<SVGSVGElement> & { name: FunctionalIconName }) {
  const Icon = icons[name];
  return <Icon {...props} aria-hidden="true" className={`inline-block h-[1em] w-[1em] shrink-0 align-[-0.125em] ${className}`} />;
}
